export let ListenerEvent = /*#__PURE__*/function (ListenerEvent) {
  /**
   * Invoked when the user opens the SDK.
   */
  ListenerEvent["SUPPORT_OPENED"] = "EVENT_SUPPORT_OPENED";
  /**
   * Invoked when the user closes the SDK.
   */
  ListenerEvent["SUPPORT_CLOSED"] = "EVENT_SUPPORT_CLOSED";
  /**
   * Invoked when any of the operators are online.
   */
  ListenerEvent["OPERATORS_ONLINE"] = "EVENT_OPERATORS_ONLINE";
  /**
   * Invoked when all the operators are offline.
   */
  ListenerEvent["OPERATORS_OFFLINE"] = "EVENT_OPERATORS_OFFLINE";
  /**
   * Invoked when the visitor's IP is blocked.
   */
  ListenerEvent["VISITOR_IPBLOCKED"] = "EVENT_VISITOR_IPBLOCKED";
  /**
   * Invoked when the visitor's registration is failed due to data corruption
   * or any other failures.
   */
  ListenerEvent["VISITOR_REGISTRATION_FAILURE"] = "EVENT_VISITOR_REGISTRATION_FAILURE";
  /**
   * This event allows you to open a URL when invoked. When using this event followed by a URL, this will open the mentioned URL.
   */
  ListenerEvent["OPEN_URL"] = "EVENT_OPEN_URL";
  /**
   * This event will complete the chat action as a success or failure, with or without a message
   */
  ListenerEvent["COMPLETE_CHAT_ACTION"] = "EVENT_COMPLETE_CHAT_ACTION";
  return ListenerEvent;
}({});
export let ZSIQTabs = /*#__PURE__*/function (ZSIQTabs) {
  ZSIQTabs["CONVERSATIONS"] = "TAB_CONVERSATIONS";
  ZSIQTabs["KNOWLEDGE_BASE"] = "TAB_KNOWLEDGE_BASE";
  /**
   * @deprecated
   */
  ZSIQTabs["FAQ"] = "TAB_FAQ";
  return ZSIQTabs;
}({});
export let LauncherProps = /*#__PURE__*/function (LauncherProps) {
  LauncherProps[LauncherProps["MODE_STATIC"] = 1] = "MODE_STATIC";
  LauncherProps[LauncherProps["MODE_FLOATING"] = 2] = "MODE_FLOATING";
  LauncherProps["HORIZONTAL_LEFT"] = "LAUNCHER_HORIZONTAL_LEFT";
  LauncherProps["HORIZONTAL_RIGHT"] = "LAUNCHER_HORIZONTAL_RIGHT";
  LauncherProps["VERTICAL_TOP"] = "LAUNCHER_VERTICAL_TOP";
  LauncherProps["VERTICAL_BOTTOM"] = "LAUNCHER_VERTICAL_BOTTOM";
  return LauncherProps;
}({});
//# sourceMappingURL=Listener.js.map